module.exports = __webpack_public_path__ + "img/indochine-2024.5db55244.jpg";